module.exports = __webpack_public_path__ + "img/tag_xj@2x.2e1678c6.svg";